// TODO: figure out a more react way of doing this

// CSS that allows specific elements to keep their transitions
const disableTransitionsWithExceptionsCSS = `
*:not(.keep-transitions *) {
  -webkit-transition: none !important;
  -moz-transition: none !important;
  -o-transition: none !important;
  -ms-transition: none !important;
  transition: none !important;
}
`

export function disableTransitions() {
	const styleId = 'disable-transitions'

	// Remove any existing style with the same ID
	const existingStyle = document.getElementById(styleId)
	if (existingStyle) {
		existingStyle.remove()
	}

	// Create new style element
	const style = document.createElement('style')
	style.id = styleId
	style.textContent = disableTransitionsWithExceptionsCSS

	document.head.appendChild(style)

	// Return cleanup function
	const cleanup = () => {
		const currentStyle = document.getElementById(styleId)
		if (currentStyle) {
			currentStyle.remove()
		}
	}

	setTimeout(cleanup, 100)

	return cleanup
}
